// Record Delivery success (mock success anatomy): large okbox with the BL number, delivered-vs-dispatched table, what was posted.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Emo } from '../../../shell/EmojiIcons';
import { formatDate, formatQty } from '../../../utils/format';
import { FeeSlicesPosted, DeliveryValue } from './DeliveryFees';
import { qtyText, unitGroups, groupsText } from '../dispatchUnits.mjs';

const fq = (q, l) => qtyText(q, l, formatQty);
const sum = (rows, key) => groupsText(unitGroups(rows.map(x => ({ qty: x[key], line: x.line }))), formatQty);

export function DeliveredSummary({ done }) {
  const { t } = useTranslation('delivery');
  const slip = !!done.slip;
  const rows = done.rows;
  const delivered = rows.filter(x => x.got > 0);
  const notDelivered = rows.filter(x => x.got === 0);
  const back = rows.filter(x => slip && x.sent - x.got > 0).map(x => ({ line: x.line, qty: x.sent - x.got }));
  const left = rows.filter(x => x.left > 0).map(x => ({ line: x.line, qty: x.left }));
  const leftText = groupsText(unitGroups(left.map(x => ({ qty: x.qty, line: x.line }))), formatQty);
  const nodes = done.nodes || '—';
  return (<>
    <div className="okbox succ" data-testid="delivery-done-box">
      <div><Emo name="check" /> {t(done.slip?.pickup ? 'done.headlinePickup' : 'done.headline')}</div>
      {slip && <div className="bl" data-testid="delivery-done-no">{done.slip.no}</div>}
      <div>{slip ? t('done.summarySlip', { got: sum(delivered.map(x => ({ line: x.line, q: x.got })), 'q'), sent: sum(rows.map(x => ({ line: x.line, q: x.sent })), 'q') }) : t('done.summaryDirect', { got: sum(delivered.map(x => ({ line: x.line, q: x.got })), 'q') })} · {t('done.on', { date: formatDate(done.date) })}</div>
      {!slip && <div>{t('pick.direct')}</div>}
      {done.replay && <div>{t('done.replay')}</div>}
    </div>
    <div>
      <div className="sec-lab">{t(slip ? 'done.secSlip' : 'done.secDirect')}</div>
      <div className="gtable-wrap dsp-table" style={{ overflowX: 'auto' }}><table className="gtable zebra" data-testid="delivery-done-lines">
        <thead><tr><th>{t('done.colItem')}</th>{slip && <th className="r">{t('done.colDispatched')}</th>}<th className="r">{t('done.colDelivered')}</th>{slip ? <th className="r">{t('done.colBack')}</th> : null}</tr></thead>
        <tbody>{rows.map(x => (
          <tr key={x.line.sale_id}><td>{x.line.item_name || '—'}</td>
            {slip && <td className="r num">{fq(x.sent, x.line)}</td>}
            <td className="r num">{x.got > 0 ? fq(x.got, x.line) : <span className="rd-nd"><b>{t('slip.notDelivered')}</b></span>}</td>
            {slip ? <td className="r num">{x.sent - x.got > 0 ? fq(x.sent - x.got, x.line) : '—'}</td> : null}</tr>))}
        </tbody></table></div>
      {notDelivered.length > 0 && <div className="rd-nd" style={{ marginTop: 6 }}>{t('slip.notDeliveredSummary', { items: notDelivered.map(x => x.line.item_name || '—').join(', ') })}</div>}
      {back.length > 0 && <div className="rd-nd" style={{ marginTop: 6 }}>{t('done.short', { short: sum(back, 'qty') })}</div>}
      <div className="rd-nd" style={{ marginTop: 6 }}>{left.length ? t('done.remaining', { qty: leftText }) : t('done.remainingNone')}</div>
    </div>
    <div>
      <div className="sec-lab">{t('done.posted')}</div>
      <dl className="dsp-facts" data-testid="delivery-done-posted">
        <dt>{t('done.lblCogs')}</dt><dd>{t('done.cogsVal')}</dd>
        <dt>{t('done.lblStock')}</dt><dd>{nodes}</dd>
        {done.ledger > 0 && <><dt>{t('done.lblLedger')}</dt><dd>{t('done.ledger', { count: done.ledger })}</dd></>}
      </dl>
    </div>
    <DeliveryValue lines={done.valueLines} totals={done.totals} posted />
    <FeeSlicesPosted slices={done.feeSlices} names={done.feeNames || {}} />
    <div className="hint"><Emo name="link" /> {t(slip ? 'done.hintSlip' : 'done.hintDirect')}</div>
  </>);
}
